
import { mapGetters } from 'vuex'
import SearchCard from '../Search/SearchCard.vue'
import EralpPagination from 'gurhan/vue/BootstrapPagination.vue'
import ProductAlert from './ProductAlert.vue'
import NoFound from '../Shared/NoFound/index.vue'
import Payment from './Payment'
import Upload from '../Shared/Upload/index.vue'
import Accordion from '../Shared/Accordion/index.vue'
import ProductVideo from './ProductVideo.vue'
import Modal from '../Shared/Modal/index.vue'
import { formatter } from '~/plugins/date'
import GetOffer from './GetOffer.vue'
import AnswerToOffer from './AnswerToOffer.vue'
import Purchase from '@/components/Contents/PurchaseAction/Purchase.vue'
export default {
  components: {
    SearchCard,
    NoFound,
    EralpPagination,
    ProductAlert,
    Upload,
    Accordion,
    ProductVideo,
    GetOffer,
    AnswerToOffer,
    Purchase,
    Modal,
  },
  mixins: [Payment],
  data() {
    return {
      page: 1,
      products: [],
      product: {},
      showPayments: false,
      activeItem: {
        modal: false,
        item: {
          title: '',
          videoPath: '',
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      getRedirectUrl: 'getRedirectUrl',
      getUserIP: 'user/getUserIP',
      getCourses: 'profile.courses/getCourses',
      getCount: 'profile.courses/getCoursesCount',
      getCoursesLoading: 'profile.courses/getCoursesLoading',
    }),
    pages() {
      return Math.ceil(this.getCount / 12)
    },
  },
  methods: {
    formatter,
    BUY_IT_OFFER(product) {
      this.product = product
      this.showPayments = true
    },
    SET_ACTIVE_ITEM(item) {
      this.activeItem = {
        modal: true,
        item: item,
      }
    },
    PERCENT(item) {
      if (item.totalVideoCount === 0) return 0
      return Math.round((item.completedVideoCount * 100) / item.totalVideoCount)
    },
    async SET_PAGINATION(page) {
      this.page = page
      this.products = await this.$store.dispatch(
        'profile.courses/GET_COURSES',
        {
          page: this.page,
          currency: this.getUserIP.currency,
        }
      )
    },
    SET_REMAIN_DATE(date) {
      const moment = require('moment-timezone')
      moment.locale(this.$i18n.locale)
      return this.$custom$t('remainDate', { date: moment(date).fromNow() })
    },
  },
  async mounted() {
    this.products = await this.$store.dispatch('profile.courses/GET_COURSES', {
      page: 1,
      currency: this.getUserIP.currency,
    })
    this.GET_PAYMENT_LIST()
  },
}
